"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STAGED_FONTS_STYLE_ID = exports.STAGED_FONTS_STORAGE_KEY = void 0;
var STAGED_FONTS_STYLE_ID = 'staged-fonts-style';
exports.STAGED_FONTS_STYLE_ID = STAGED_FONTS_STYLE_ID;
var STAGED_FONTS_STORAGE_KEY = 'staged-fonts';
exports.STAGED_FONTS_STORAGE_KEY = STAGED_FONTS_STORAGE_KEY;